import React from 'react'
import MainHeader from '../components/MainHeader/MainHeader'
import Spinner from './Spinner'

function LoadingViewer() {
  return (
    <div>
      <MainHeader />
      <div className="container-fluid mt-7">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex flex-column justify-content-center align-items-center flex-nowrap min-vh-100">
              <Spinner />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingViewer
